import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivityTypes_activityTypes as ActivityType,
    GetActivityTypes as GetActivityTypesQuery,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_TYPES from '../queries/get-activity-types.graphql';

export const useGetActivityTypes = (): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    activityTypes: ActivityType[];
} => {
    const {loading, data, error} = useQuery<GetActivityTypesQuery, Record<any, any>>(
        GET_ACTIVITY_TYPES,
        {
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        activityTypes: data && data.activityTypes ? data.activityTypes : [],
    };
};
